import { render, staticRenderFns } from "./CalendarHeader.vue?vue&type=template&id=0bda2840&scoped=true&"
import script from "./CalendarHeader.vue?vue&type=script&lang=js&"
export * from "./CalendarHeader.vue?vue&type=script&lang=js&"
import style0 from "./CalendarHeader.vue?vue&type=style&index=0&id=0bda2840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda2840",
  null
  
)

export default component.exports